<template>
  <div>
    <div class="d-flex flex-column tab-card-form">
      <div class="element-info">
        <div class="row align-items-center">
          <div class="col-8">
            <div class="element-info-with-icon">
              <div class="element-info-icon">
                <fontAwesomeIcon :icon="['fas', 'plus-circle']" size="2x" />
              </div>
              <div class="element-info-text ml-5">
                <h5 class="element-inner-header"> Widget Configuration </h5>
                <div class="element-inner-desc"> Here you can change the widget configurations. </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project-box d-flex flex-column">
        <div class="project-head">
          <div class="project-title">
            <h5 v-if="!mobile" class="py-2 element-header"> Manage Widgets Permissions </h5>
            <h5 v-else class="py-2 pt-4 text-center"> Manage Widgets Permissions </h5>
          </div>
        </div>
        <div class="row">
          <ResponseInfo v-if="getResponseInfo.responseName == 'widgetsCollection'" class="mt-3"/>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="loading">
              <vcl-table :rows="5" :columns="9"></vcl-table>
            </div>
            <div v-else class="table-responsive">
              <table class="table b-table table-striped table-hover">
                <thead class="brand-color">
                  <tr v-if="userLevelList">
                    <th> Widget name </th>
                    <th> Widget Component </th>
                    <th> Active </th>
                    <th v-for="level in userLevelList" :key="level.id">{{ level.name }}</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="widget in widgetsList" :key="widget.id">
                  <td>{{ t(widget.translation_key, widget.translation_key) }}</td>
                  <td>{{ t(getComponentName(widget.widget_name))}}</td>
                  <td>
                    <b-form-checkbox v-model="widget.is_active" @change="updateWidgetState(widget.id, $event)" value=1 unchecked-value=0></b-form-checkbox>
                  </td>
                  <td v-for="(value, key) in widget.permissions" :key="widget.id + key">
                    <b-form-checkbox :checked="value == 1" @change="updatePermission(key, widget.id, $event)"></b-form-checkbox>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 text-right mt-3">
            <button class="btn btn-primary" @click="openNewWidgetModal()"> Create Widget </button>
          </div>
        </div>
      </div>
    </div>
    <ModalWidgetConfiguration :userLevels="userLevelList" :widgetComponents="allWidgets"/>
    <div class="modal-backdrop show" v-if="showModal"></div>
  </div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo.vue'
import ModalWidgetConfiguration from '@/components/Site_setup/ModalWidgetConfiguration.vue'
import { mapGetters } from 'vuex'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'SiteSetupWidgetConfiguration',
  components:{
    ResponseInfo,
    ModalWidgetConfiguration,
    VclTable
  },
  computed: {
    ...mapGetters(['getResponseInfo'])
  },
  data() {
    return {
      widgetsList: [],
      showModal: false,
      userLevelList: null,
      loading: false,
      // NEED TO ADD A NEW WIDGET OPTION EVERY TIME A NEW WIDGET IS CREATED !!!!!!
      allWidgets: [
        {name: 'documentsOverviewStatsWidget' , value: 'DocumentsOverviewStats'},
        {name: 'portalUseStatsWidget' , value: 'PortalUseStats'},
        {name: 'deliveryMethodsWidget' , value: 'DeliveryMethodsChart'},
        {name: 'batchesStatusChartWidget' , value: 'BatchesStatusChart'},
        {name: 'electronicConversionsWidget' , value: 'ElectronicConversionsChart'},
        {name: 'documentsCountChartWidget' , value: 'DocumentsCountChart'},
        {name: 'emailStatsChartWidget' , value: 'EmailStatsChart'},
        {name: 'documentsPaymentsChartWidget' , value: 'DocumentsPaymentsChart'},
      ],
      mobile: window.innerWidth <= 700
    }
  },
  methods: {
    getComponentName(name) {
      let result = this.allWidgets.find(obj => {
        return obj.value === name
      })

      if (!result) {
        return name
      }

      return result.name
    },
    getWidgetsPermissions() {
      this.loading = true
      this.$store.dispatch('alertClearResponse')
      this.$store.dispatch('widgetsStore/getWidgetsPermissions').then(response => {
        this.widgetsList = response.widgets

        if(response.userLevels) {
          this.userLevelList = response.userLevels
        }
      }).finally(()=> {
        this.loading = false
      })
    },
    openNewWidgetModal() {
      this.showModal = true
      this.$root.$emit('bv::show::modal', 'newWidgetModal')
    },
    closeNewWidgetModal() {
      this.showModal = false
      this.$root.$emit('bv::hide::modal', 'newWidgetModal')
    },
    updatePermission(userLevel, widgetId, event) {
      this.$store.dispatch('alertClearResponse')
      this.$store.dispatch('widgetsStore/updateWidgetPermissions', {
        permission: event,
        userLevel: userLevel,
        widgetId: widgetId
      })
    },
    updateWidgetState(widgetId, event) {
      this.$store.dispatch('alertClearResponse')
      this.$store.dispatch('widgetsStore/updateWidgetStatus', {
        widgetId: widgetId,
        active: event
      })
    },
  },
  created() {
    this.getWidgetsPermissions()

    window.addEventListener('resize', () => {
      this.mobile = window.innerWidth <= 700
    })
  }
}

</script>

<style scoped>
.tab-card-form{
  min-width: 70% !important;
}
</style>